// extracted by mini-css-extract-plugin
module.exports = {"container":"P12iyVIBZy8Mog3nS2-XR"};